import React from "react";
import { FaCheck, FaDownload, FaExchangeAlt, FaRegEye } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import Swal from "sweetalert2";
import axios from "axios";
import { serverApi, serverUrl, downloadUrl } from "../../../confing/confing";
import toast from "react-hot-toast";
let token = localStorage.getItem("token");

const DetailsModal = ({ item , setSelected }) => {
  const changeStatus = async (item) => {
    try {
      const url = `${serverUrl}/admin/sheet/status/${item.Ex_Expertors.id}`;
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const { data } = await axios.put(
        url,
        {},
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      console.log(data);
      Swal.close();
      toast.success("دسترسی به کارشناس جهت ویرایش انجام شد");
      console.log(data);
    } catch (err) {
      console.log(err);
      Swal.close();
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };

  const showDetails = async (item) => {
    try {
      const url = `${serverApi}sheet/info/${item.Ex_Expertors.ExSheetId}`;
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const { data } = await axios.get(url, {
        headers: { authorization: `Bearer ${token}` },
      });
      Swal.close();
      Swal.fire({
        icon: "success",
        title: `اطلاعات با موفقیت دریافت شد`,
        text: `نوع ملک ثبت شده توسط کارشناس ${data.result.Category}  و منطقه ثبت شده ${data.result.Zone} می باشد. لطفا نوع ملک و منطقه ثبت شده توسط کارشناس را چک کنید و اقدامات لازم را انجام دهید.`,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText:"بستن"
      });
    } catch (err) {
      console.log(err);
      Swal.close();
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };

  const FinalApproval = async (item) => {
    try {
      const url = `${serverApi}sheet/addAdminCheck`;

      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const { data } = await axios.post(
        url,
        { ExSheetId: item.Ex_Expertors.id },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      console.log(data);
      Swal.close();
      toast.success("تایید نهایی با موفقیت انجام شد");
      console.log(data);
    } catch (err) {
      console.log(err);
      Swal.close();
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };

  const downloadSheet = async (item) => {
    console.log(item);
    try {
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      console.log(item.Ex_Expertors.id);
      const { data } = await axios.get(
        `${downloadUrl}expert/sheet2/${item.Ex_Expertors.ExSheetId}`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      console.log(data);
      const link = document.createElement("a");
      link.href = `${downloadUrl}sheet/d/${data.result.fileName}`;
      // console.log(item)
      link.download = data.result.fileName;
      link.click();
      Swal.close();
      console.log(data);
    } catch (err) {
      console.log(err);
      Swal.close();
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  return (
    <div>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog " style={{ maxWidth: "80%" }}>
          <div className="modal-content ">
            {item.address && (
              <div className="modal-body">
                <div className="row text-end ">
                  <div className="col-6 mb-2">
                    <p className="mb-1">آدرس : </p>
                    <input
                      className="w-100"
                      defaultValue={item.address}
                      disabled
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <p className="mb-1">شماره تماس مالک</p>
                    <input
                      className="w-100"
                      defaultValue={item.Ex_Owner.tel}
                      disabled
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <p className="mb-1">نوع واجد ثبت شده توسط مالک: </p>
                    <input
                      className="w-100"
                      defaultValue={item.Ex_Category.name}
                      disabled
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <p className="mb-1">منطقه ثبت شده توسط مالک :</p>
                    <input
                    className="w-100"
                    defaultValue={item.Ex_Zone.name}
                    disabled
                  />
                  </div>
                </div>
                <div className="mt-3 text-end">
                  <h4>لیست کارشناس ها : </h4>
                  <table
                    className="table table-bordered text-center mb-0 "
                    style={{ borderRadius: "20px" }}
                  >
                    <thead>
                      <tr style={{ color: "#000" }}>
                        <th scope="col">ردیف</th>
                        <th scope="col">نام کارشناس</th>
                        <th scope="col">شماره تماس</th>
                        <th scope="col">زمان رزرو شده </th>
                        <th scope="col">نوع پرداخت</th>
                        <th scope="col">وضعیت</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.expert.map((i, index) => (
                        <tr style={{ color: "#000" }} key={index}>
                          <td>{index + 1}</td>
                          <td>{i.name}</td>
                          <td>{i.mobile}</td>
                          <td>{i.Ex_Expertors.faDateTime}</td>
                          <td>
                            {i.Ex_Expertors?.clearingMethod === "POS"
                              ? "کارت خوان"
                              : i.Ex_Expertors?.clearingMethod === "Online"
                              ? "آنلاین"
                              : i.Ex_Expertors?.clearingMethod === "Cash"
                              ? "نقدی"
                              : ""}
                          </td>
                          <td>
                            {i.Ex_Expertors?.status === "WaitingForPay"
                              ? "در انتظار پرداخت"
                              : i.Ex_Expertors?.status === "Pending"
                              ? "در انتظار ثبت"
                              : i.Ex_Expertors?.status === "Finish"
                              ? "ثبت نهایی"
                              : i.Ex_Expertors?.status === "Reject"
                              ? "رد شده"
                              : i.Ex_Expertors?.status === "Cancel"
                              ? "لغو شده"
                              : i.Ex_Expertors?.status === "Approved"
                              ? "ثبت اولیه"
                              : ""}
                          </td>

                          <td>
                            {i.Ex_Expertors?.status === "Finish" ? (
                              <div className="d-flex">
                                <div>
                                  <button id="download" className="btn">
                                    <FaDownload
                                      onClick={() => {
                                        downloadSheet(i);
                                      }}
                                    />
                                  </button>
                                </div>
                                <div>
                                  <button
                                    id="download"
                                    className="btn"
                                    onClick={() => {
                                      changeStatus(i);
                                    }}
                                  >
                                    <FaExchangeAlt />
                                  </button>
                                </div>
                              </div>
                            ) : i.Ex_Expertors?.status === "Approved" ? (
                              <div className="d-flex">
                                <div>
                                  <button
                                    id="download"
                                    className="btn"
                                    onClick={() => {
                                      showDetails(i);
                                    }}
                                  >
                                    <FaRegEye />
                                  </button>
                                </div>
                                <div>
                                  <button
                                    id="download"
                                    className="btn"
                                    onClick={() => {
                                      FinalApproval(i);
                                    }}
                                  >
                                    <FaCheck />
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={()=>{setSelected({})}}
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsModal;
